import React from 'react';
import { Twitch, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

function GoogleLogo({ className = 'w-4 h-4' }) {
  // Brand Google "G" — kept inline to avoid extra deps.
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.2 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.3 0-9.7-3.4-11.3-8L6.2 33C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.2 5.2C40.9 35.8 44 30.4 44 24c0-1.2-.1-2.4-.4-3.5z"
      />
    </svg>
  );
}

export default function LoginDialog() {
  const { dialogOpen, closeLogin, loginTwitch, loginGoogle } = useAuth();
  if (!dialogOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      data-testid="login-dialog"
    >
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={closeLogin}
      />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-zinc-950 p-6 shadow-2xl">
        <button
          onClick={closeLogin}
          className="absolute top-3 right-3 p-1.5 rounded-md text-zinc-500 hover:text-white hover:bg-white/5"
          aria-label="sluiten"
          data-testid="login-dialog-close"
        >
          <X className="w-4 h-4" />
        </button>

        <h2 className="text-2xl font-black tracking-tight text-white">
          Inloggen
        </h2>
        <p className="text-sm text-zinc-400 mt-1">
          Kies hoe je wilt inloggen om suggesties in te dienen en te stemmen.
        </p>

        <div className="mt-6 space-y-3">
          <button
            onClick={loginTwitch}
            data-testid="login-twitch-btn"
            className="w-full inline-flex items-center justify-center gap-3 px-5 py-3 rounded-lg bg-violet-600 hover:bg-violet-500 text-white font-semibold transition-colors"
          >
            <Twitch className="w-5 h-5" /> Doorgaan met Twitch
          </button>

          <button
            onClick={loginGoogle}
            data-testid="login-google-btn"
            className="w-full inline-flex items-center justify-center gap-3 px-5 py-3 rounded-lg bg-white hover:bg-zinc-100 text-zinc-900 font-semibold transition-colors"
          >
            <GoogleLogo className="w-5 h-5" /> Doorgaan met Google
          </button>
        </div>

        <p className="text-[11px] text-zinc-500 mt-5 text-center">
          Alleen Twitch-login geeft (voor de broadcaster) toegang tot het admin
          dashboard. Google-gebruikers kunnen stemmen en suggesties indienen.
        </p>
      </div>
    </div>
  );
}
